import { Lkup_Inst } from './lkup_Inst';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { LAttribute } from 'src/app/shared/models/domain/lattribute';
import { Lkup_Inst_Cnd } from 'src/app/shared/models/domain/lkup_inst_cnd';
import { Attribute } from './attribute';
import { Lkup_Inst_CndUtil } from 'src/app/shared/utils/lkup_inst_cnds.util';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';

export class LookUp {
    lkup_Inst: Lkup_Inst;
    lkup_Inst_Cnds: Array<Lkup_Inst_Cnd>;

    lAttributes: Array<LAttribute>;
    attributes: Array<Attribute>;

    lookUp_Properties: Array<Obj_Db_Property>;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;
    prop_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    gen_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.lkup_Inst = new Lkup_Inst();
        this.lkup_Inst_Cnds = new Array<Lkup_Inst_Cnd>();

        this.lAttributes = new Array<LAttribute>();
        this.attributes = new Array<Attribute>();

        this.lookUp_Properties = new Array<Obj_Db_Property>();
        this.run_Properties = new Array<Obj_Db_Property>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_VAL_NO;
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(lookUpTmp: LookUp): LookUp {
        let lookUp: LookUp = new LookUp();
        lookUp.copyFrom(lookUpTmp);
        return lookUp;
    }

    copy(): LookUp {
        let lookUpTmp: LookUp = new LookUp();

        // lookUpTmp.lkup_Inst = this.lkup_Inst.copy();
        lookUpTmp.lkup_Inst = this.lkup_Inst;
        lookUpTmp.lkup_Inst_Cnds = Lkup_Inst_CndUtil.getInstance().copy(this.lkup_Inst_Cnds);

        lookUpTmp.lAttributes = LAttributesUtil.getInstance().copy(this.lAttributes);
        lookUpTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance()
        lookUpTmp.lookUp_Properties = obj_Db_PropertiesUtil.copy(this.lookUp_Properties);
        lookUpTmp.run_Properties = obj_Db_PropertiesUtil.copy(this.run_Properties);

        lookUpTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        lookUpTmp.ref_Id = this.ref_Id;
        lookUpTmp.ref_Cd = this.ref_Cd;
        lookUpTmp.fldr_Id = this.fldr_Id;
        lookUpTmp.is_In_SubFlow = this.is_In_SubFlow;
        lookUpTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;

        lookUpTmp.change_Ind = this.change_Ind;
        lookUpTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        lookUpTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        lookUpTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;

        lookUpTmp.error_Cd = this.error_Cd;
        lookUpTmp.error_Msg = this.error_Msg;

        return lookUpTmp;
    }

    copyFrom(lookUpTmp: LookUp): void {
        this.lkup_Inst.copyFrom(lookUpTmp.lkup_Inst);
       // this.lkup_Inst = lookUpTmp.lkup_Inst;
        Lkup_Inst_CndUtil.getInstance().copyFrom(this.lkup_Inst_Cnds, lookUpTmp.lkup_Inst_Cnds);

        LAttributesUtil.getInstance().copyFrom(this.lAttributes, lookUpTmp.lAttributes);
        AttributesUtil.getInstance().copyFrom(this.attributes, lookUpTmp.attributes);

        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        obj_Db_PropertiesUtil.copyFrom(this.lookUp_Properties, lookUpTmp.lookUp_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.run_Properties, lookUpTmp.run_Properties);

        this.nativeDbTyp_Id = lookUpTmp.nativeDbTyp_Id;
        this.ref_Id = lookUpTmp.ref_Id;
        this.ref_Cd = lookUpTmp.ref_Cd;
        this.fldr_Id = lookUpTmp.fldr_Id;
        this.is_In_SubFlow = lookUpTmp.is_In_SubFlow;
        this.sel_Run_PropertyType_Cd = lookUpTmp.sel_Run_PropertyType_Cd;

        this.change_Ind = lookUpTmp.change_Ind;
        this.prop_Tab_Change_Ind = lookUpTmp.prop_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = lookUpTmp.attr_Tab_Change_Ind;
        this.gen_Tab_Change_Ind = lookUpTmp.gen_Tab_Change_Ind;

        this.error_Cd = lookUpTmp.error_Cd;
        this.error_Msg = lookUpTmp.error_Msg;
    }

    compare(lookUpTmp: LookUp): string {
        let lookUpString: string = this.toString();
        let lookUpTmpString: string = lookUpTmp.toString();

        if (lookUpString != lookUpTmpString) {
            return lookUpString + ', ' + lookUpTmpString;
        }

        return '';
    }

    toString(): string {
        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        
        return "LookUp [  lkup_Inst=" + this.lkup_Inst.toString() +
            ", lkup_Inst_Cnds = " + Lkup_Inst_CndUtil.getInstance().toString(this.lkup_Inst_Cnds) +
            ", lAttributes  = " + LAttributesUtil.getInstance().toString(this.lAttributes) +
            ", attributes = " + AttributesUtil.getInstance().toString(this.attributes) +
            ", nativeDbTyp_Id=" + this.nativeDbTyp_Id + ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id +
            ", is_In_SubFlow=" + this.is_In_SubFlow +
            ", lookUp_Properties=" + obj_Db_PropertiesUtil.toString(this.lookUp_Properties) +
            ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd +
            ", run_Properties=" + obj_Db_PropertiesUtil.toString(this.run_Properties) +
            ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind + ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + "]";
    }
}